import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { NotifyComponent } from './notify.component';
import {
  NotifyType,
  NOTIFY_TYPE_DANGER,
  NOTIFY_TYPE_DEFAULT,
  NOTIFY_TYPE_SUCCESS,
  NOTIFY_TYPE_WARNING
} from './notify-types';


@Injectable()
export class NotifyService {
  constructor(private snackBar: MatSnackBar) { }

  success(msg: string) {
    this.show(msg, NOTIFY_TYPE_SUCCESS);
  }

  danger(msg: string) {
    this.show(msg, NOTIFY_TYPE_DANGER);
  }

  warning(msg: string) {
    this.show(msg, NOTIFY_TYPE_WARNING);
  }

  show(msg: string, type: NotifyType = NOTIFY_TYPE_DEFAULT  ) {
    this.snackBar.openFromComponent(NotifyComponent, {
      duration: 3000,
      data: {
        msg: msg,
        type: type
      }
    });
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms/src/notify/notify.service.ts